import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query'
import { getRequest, postRequest, putRequest, deleteRequest } from 'utils/http'

const EVENT_HIGHLIGHTS_QUERY_KEY = 'event-highlights'

export const getEventHighlights = async () => {
  return await getRequest('event-highlights')
}

export const useGetEventHighlights = () => {
  return useQuery({
    queryKey: [EVENT_HIGHLIGHTS_QUERY_KEY],
    queryFn: getEventHighlights,
  })
}

export const createEventHighlight = async formData => {
  return postRequest('event-highlights', formData)
}

export const useCreateEventHighlight = () => {
  const queryClient = useQueryClient()
  return useMutation({
    mutationFn: createEventHighlight,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: [EVENT_HIGHLIGHTS_QUERY_KEY] })
    },
    onError: error => {
      console.error('Failed to create event highlight:', error)
    },
  })
}

export const updateEventHighlight = async formData => {
  const id = formData.get('id')
  return postRequest(`event-highlights/${id}`, formData)
}

export const useUpdateEventHighlight = () => {
  const queryClient = useQueryClient()
  return useMutation({
    mutationFn: updateEventHighlight,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: [EVENT_HIGHLIGHTS_QUERY_KEY] })
    },
    onError: error => {
      console.error('Failed to update event highlight:', error)
    },
  })
}

export const deleteEventHighlight = async id => {
  return deleteRequest(`event-highlights/${id}`)
}

export const useDeleteEventHighlight = () => {
  const queryClient = useQueryClient()
  return useMutation({
    mutationFn: deleteEventHighlight,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: [EVENT_HIGHLIGHTS_QUERY_KEY] })
    },
    onError: error => {
      console.error('Failed to delete event highlight:', error)
    },
  })
}

export const getEventHighlightsMotionSetting = async () => {
  return await getRequest('event-highlights/motion-setting')
}

export const useGetEventHighlightsMotionSetting = () => {
  return useQuery({
    queryKey: ['event-highlights-motion'],
    queryFn: getEventHighlightsMotionSetting,
  })
}

export const updateEventHighlightsMotionSetting = async isMotionEnabled => {
  return putRequest('event-highlights/motion-setting', { is_motion_enabled: isMotionEnabled })
}

export const useUpdateEventHighlightsMotionSetting = () => {
  const queryClient = useQueryClient()
  return useMutation({
    mutationFn: updateEventHighlightsMotionSetting,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['event-highlights-motion'] })
    },
    onError: error => {
      console.error('Failed to update event highlights motion setting:', error)
    },
  })
}

